import { Page } from '../page';

export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
export const SET_REPORT_AVAILABLE = 'SET_REPORT_AVAILABLE';

export function setActivePage(page: Page) {
	return {
		type: SET_ACTIVE_PAGE,
		activePage: page,
	};
}
export function setReportAvailable(reportAvailable: boolean) {
	return {
		type: SET_REPORT_AVAILABLE,
		reportAvailable,
	};
}